// Константы загрузки файлов
export const UploadConstants = {
    // максимальный размер в байтах
    MAX_UPLOAD_SIZE: 1024 * 1024 * 20,
    // поддерживаемые форматы для импорта из файлов
    ALLOW_IMPORT_FILE_EXTENSIONS: ['txt', 'csv'],
}
